var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuspend = function SvgSuspend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1C4.36427 1 1 4.36422 1 8.5C1 12.6357 4.36427 16 8.5 16C12.6357 16 16 12.6357 16 8.5C16 4.36422 12.6357 1 8.5 1ZM1.93751 8.5C1.93751 6.85921 2.54714 5.36089 3.54621 4.20902L12.791 13.4538C11.6391 14.4529 10.1408 15.0625 8.5 15.0625C4.88155 15.0625 1.93748 12.1184 1.93751 8.5ZM13.4538 12.791L4.20908 3.54621C5.36092 2.54714 6.85923 1.93751 8.50005 1.93751C12.1185 1.93751 15.0625 4.88155 15.0625 8.5C15.0625 10.1408 14.4529 11.6391 13.4538 12.791Z",
    fill: "#0EBE88",
    stroke: "#0EBE88",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuspend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/suspend.f33c5215.svg";
export { ForwardRef as ReactComponent };